import React from 'react';
import PropTypes from 'prop-types';
import config from '../../../../config/config';
import If from '../../../Shared/If/If';
import ToolTip from '../../../Shared/ToolTip/ToolTip';
import { TOOLTIP_POSITION_BOTTOM } from '../../../../utils/dom-utils';
import threeStarIcon from '../../../../assets/images/scs-icons/three-star-icon.svg';
import exclamation from '../../../../assets/images/exclamation.svg';

import './InlineMessage.scss';

function ClosedFundEligibleMessage({ isEligible, isExchange }) {
  return (
    <div className="inline-fund-message">
      <If test={isEligible}>
        <p>
          <span>
            <img
              alt="three star icon"
              src={threeStarIcon}
              className="inline-icon"
            />
          </span>
          Your{' '}
          <ToolTip
            theme="dark"
            header="Summit Balance"
            maxNoteWidth="400px"
            message={
              <div className="inline-message-tooltip">
                <p className="inline-message-tooltip_main">
                  The T. Rowe Price Summit Program is designed to equip you with
                  exclusive benefits to help you achieve better outcomes. As you
                  save more for retirement and other goals, you can achieve
                  higher membership status and gain entry to more and more
                  benefits, like access to closed funds, access to lower-cost I
                  Class shares and unique insights from our investment
                  professionals.
                </p>
                <p className="inline-message-tooltip_main">
                  Visit{' '}
                  <a
                    target="_blank"
                    href="https://www.troweprice.com/personal-investing/about/client-benefits/faqs.html"
                    rel="noreferrer"
                  >
                    Summary Program FAQs
                  </a>{' '}
                  for additional information.
                </p>
              </div>
            }
            callerText={
              <div className="inline-message-tool-tip">Summit Program</div>
            }
            placement={TOOLTIP_POSITION_BOTTOM}
          />{' '}
          status makes you eligible to
          {isExchange ? ' reopen ' : ' buy back into '}
          this closed fund.
        </p>
      </If>
      <If test={!isEligible}>
        <p>
          <span>
            <img alt="warning icon" src={exclamation} className="inline-icon" />
          </span>
          {isExchange ? 'Exchanging ' : 'Buying '} back into this closed fund
          requires a minimum{' '}
          <a
            className="exclude"
            target="_blank"
            href={`${config.url}/usis/my-accounts/program-benefits`}
            rel="noreferrer"
          >
            Summit balance of $250,000
          </a>
          .
        </p>
      </If>
    </div>
  );
}

ClosedFundEligibleMessage.propTypes = {
  isEligible: PropTypes.bool,
  isExchange: PropTypes.bool,
};

export default ClosedFundEligibleMessage;
